import React, { useContext, useEffect, useState } from "react";
// styled components
import { Modal, Button, Row, Col, Form, Select, Table, Empty, Checkbox, Input, } from "antd";
import { Dropdown} from "semantic-ui-react";
// data select
import { cantidadRegistros } from "../../../../utils/dataSelectOptions";
// hooks
import { useGestionarPostulaciones } from "../../../../hooks/useGestionarPostulaciones";
import { useModalAsignarJurado } from "./useModalAsignarJurado";
import { ModalVerProyectos } from "./Modalverproyectos";
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
import { openNotification } from "../../../../utils/Notifactions";
import apiJurados from "../../../../api/Jurados/api-jurados";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import { useNavigate } from "react-router";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { TemplateContext } from "../../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";
import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";

interface IProps {
  postulaciones: Array<PostulacionModel>;
  setPostulaciones: any;
  modal: boolean;
  CancelarModal: any;
  AceptarModal: any;
}

export const ModalAsignarJurado: React.FC<IProps> = (props: IProps) => {
  const { obtenerCategoriasLineas, obtenerLineasConvocatorias, lineasconvocatoria } = useGestionarPostulaciones();
  const {
    alljurados,
    cantidadpáginas,
    cambiarCantidadPaginas,
    juradosseleccionados,
    modalverproyectos,
    setModalVerProyectos,
    juradoseleccionado,
    setJuradoSeleccionado,
    cargarJurados,
    agregarJurado,
    areas, obtenerAreas,
    datosFiltrados,
    setDatosFiltrados
  } = useModalAsignarJurado();



  const [filtros, setFiltros] = useState<any>({
    area: "",
    categoria: null,
    buscarpalabra: null
  });

  const [categorias, setCategorias] = useState<any[]>([])
  const handleAreaChange = async (id_area: number) => {
    try {
      const { data } = await apiMaestras.obtenerCategoriasAreas(id_area)
      setCategorias(data);

      setFiltros({
        ...filtros,
        area: id_area
      })
    } catch (error) {
      console.log(error)
    }
  }

  const filtrarDatos = () => {
    let filtro = alljurados
    if (filtros.buscarpalabra !== null) {
      filtro = filtro.filter((x: any) => {
        //Filtro por numero_documento
        if (x.numero_documento.includes(filtros.buscarpalabra.trim())) {
          return x
        }
        //Filtro por nombre
        if (x.primer_nombre.toUpperCase().indexOf(filtros.buscarpalabra.trim().toUpperCase()) > -1) {
          return x
        }
        //Filtro por apellido
        if (x.primer_apellido.toUpperCase().indexOf(filtros.buscarpalabra.trim().toUpperCase()) > -1) {
          return x
        }
      });
    }
    setDatosFiltrados(filtro)
  }


  const limpiarFiltros = () => {
    setDatosFiltrados(alljurados);
    setFiltros({
      area: null,
      categoria: null,
      buscarpalabra: null
    })
  }


  useEffect(() => {
    obtenerAreas()
    obtenerLineasConvocatorias()
    obtenerCategoriasLineas()
    cargarJurados()
  }, []);

  const context = useContext(TemplateContext);
  // columnas
  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => {
        return <span>{index + 1}</span>;
      },
    },
    {
      title: "Nombre jurado",
      //width: 200,
      render: (datos: any) => {
        return (
          <span>
            {datos.primer_nombre} {datos.segundo_nombre} {datos.primer_apellido} {datos.segundo_apellido}
          </span>
        );
      },
    },
    {
      title: "No. Documento",
      //width: 200,
      dataIndex: "numero_documento",
      key: "numero_documento",
    },
    {
      title: "Asignado",
      //width: 200,
      render: (datos: any) => {
        return (
          <button
            type="button"
            className="font-color-051923bf"
            style={{ cursor: "pointer", background: 'none', border: 'none', padding: 0 }}
            onClick={() => {
              setJuradoSeleccionado(datos);
              setModalVerProyectos(true);
            }}
          >{`${datos.asignado === null ? "0 proyectos" : datos.asignado.length.toString() + " proyectos"}`}</button>
        );
      },
    },
    /*{
      title: "Área",
      //width: 200,
      key: "numero_documento",
      render: (datos: any) => {
        let area = areas.find((x: any) => x.id === datos.areas_conocimientos[0].area_principal);
        if (!area || area === undefined) {
          return <span>Sin información de área</span>
        }
        return <span>{area.nombre}</span>
      }
    },
    {
      title: "Categorías",
      //width: 200,
      key: "numero_documento",
      render: (datos: any) => (
        <>
          {datos.areas_conocimientos[0].areas_conocimientos.map((x: any, i) =>
            <div key={x.nombre || x.id}>{x.nombre}</div>
          )}
        </>
      )
    },*/
    {
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Seleccionar
          </Col>
        </Row>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, datos2: any, index: number) => (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              <Checkbox checked={datos.checked} onChange={(e) => agregarJurado(datos, e)} />
            </Col>
          </Row>
      ),
    },
  ];
  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const Guardar = async () => {
    let filtropostulaciones = props.postulaciones.filter((data: any) => data.checked === true);

    // Actualiza el estado de cada postulación a "Asignado"
    await Promise.all(
      filtropostulaciones.map(async (data: any) => {
        await apiParticipantes.actualizarEstadoJurado(data.id_postulacion, "Asignado");
      })
    );

    console.log('datosFiltrados', juradosseleccionados)
    let filtrojurados = juradosseleccionados
    console.log('filtrojurados', filtrojurados)
    let newfiltropostulaciones = filtropostulaciones.map((data: any) => data.id_postulacion);

    let postulaciones = filtropostulaciones.map((x: any) => ({
      id_postulacion: x.id_postulacion,
    }));

    let payloadEstado = {
      estado: "Por evaluar",
      postulaciones: postulaciones,
    };

    // ✅ Iterar secuencialmente sobre cada jurado para evitar race conditions en el backend
    try {
      for (const jurado of filtrojurados) {
        let values = {
          projects: newfiltropostulaciones, // Mismas postulaciones para cada jurado
          juries: [jurado.id_jurado], // Solo el jurado actual
        };
        await apiJurados.guardarPostulacionesJurado(values);
        console.log(`✅ Postulacion guardada para jurado ${jurado.id_jurado}`);
      }

      await apiParticipantes.actualizarEstadoPostulacion(payloadEstado);
      await ObjNotificaciones.MSG_SUCCESS("success", "Se han asignado los jurados");
      setLoading(false)
      navigate(`/Administrador/evaluacionCriterios`);
      return props.AceptarModal();
    } catch (error) {
      console.error(error);
    }

  };

  // console.log(datosFiltrados)


  return (
    <>
      <Modal
        className="ant-modal-close-x2"
        title="Asignar jurados a proyectos seleccionados"
        style={{ top: 20 }}
        visible={props.modal}
        onCancel={props.CancelarModal}
        closeIcon="X"
        width={1400}
        footer={[
          <Button key="B_Cancelar_modalAsignarJurado" className="button-gray-ghost" onClick={props.CancelarModal}>
            Cancelar
          </Button>,
          <Button key="B_guardar_modalAsignarJurado"
            className="button-azul-radius"
            loading={loading}
            onClick={() => {
              setLoading(true)
              let filtrojurados = datosFiltrados.filter((data: any) => data.checked === true);
              if (filtrojurados.length === 0) {
                return openNotification({
                  titulo: "Error",
                  descripcion: "Debe asignar un jurado",
                  placement: "bottomRight",
                });
              }
              Guardar()
            }}
          >
            Asignar Jurados
          </Button>,
        ]}
        bodyStyle={{
          padding: 0,
        }}
        maskStyle={{
          background: "rgba(6, 100, 144 ,0.8)",
        }}
      >
        <div className="body_card">
          <Form name="basic" size="large" layout="vertical">

            <div className="row">
              <div className="col-12 col-md-4 mt-3">
                <span>Filtrar por nombre o documento</span>
                <Input
                  suffix={
                    <SearchOutlined className="font-color-051923bf" />
                  }
                  value={filtros.buscarpalabra}
                  onChange={(e) =>
                    setFiltros({
                      ...filtros,
                      buscarpalabra: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-12 col-md-4 mt-3">
                <span>Filtrar por expresión</span>
                {/* <Form.Item label="Filtrar por área" name="linea_estrategica"> */}
                <Select allowClear placeholder="Seleccionar..." style={{ width: '100%' }} value={filtros.area} onChange={handleAreaChange}>
                  {areas.map(({ id, nombre }: any) => (
                    <Select.Option key={id} value={id}>{nombre}</Select.Option>
                  ))}
                </Select>
                {/* </Form.Item> */}
              </div>
              <div className="col-12 col-md-4 mt-3">
                <span>Filtrar por categoría</span>
                {/* <Form.Item label="Filtrar por Categoría" name="categoria_linea_convocatoria"> */}
                <Select allowClear placeholder="Seleccionar..." style={{ width: '100%' }} value={filtros.categoria} onChange={(v: any) => setFiltros({ ...filtros, categoria: v })}>
                  {categorias.map(({ id, nombre }: any) => (
                    <Select.Option key={id} value={id}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
                {/* </Form.Item> */}
              </div>
              <div className="footer_card justify-content-flex-end">
                <Button className="button-azul-ghost m-0" style={{ marginRight: '10px' }} onClick={limpiarFiltros}>Limpiar filtros</Button>
                <Button className="button-azul-radius m-0" onClick={filtrarDatos}>Buscar</Button>
              </div>
            </div>

          </Form>
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular" style={{ paddingBottom: "0%" }}>
                Lista de proyectos
              </div>


              <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                <div className="d-flex flex-column flex-md-row pb-2">
                  <div className="d-flex justify-content-end pe-4">

                    Jurados seleccionados: {" "}
                    <span className="font-family-Montserrat-Regular font-color-F28C02">({juradosseleccionados.length})</span>

                  </div>
                  <div className="d-flex  justify-content-md-end">
                    <div>
                      Total: <span className="font-color-F28C02 font-family-Montserrat-Regular">{alljurados.length}</span>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end registos-adminconvocatoria pb-2" style={{ width: 200 }}>
                  <span className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </span>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadpáginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg />
                    }
                    onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                  />
                </div>

              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-12">
              <Table
                style={{ borderTop: "1px solid #C4C4C4" }}
                locale={{ emptyText: <Empty description="No hay datos" style={{ padding: "50px" }} /> }}
                pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadpáginas }}
                dataSource={datosFiltrados}
                columns={columns}
                size="small"
                bordered={false}
              />
            </div>
          </div>
        </div>
      </Modal>
      <ModalVerProyectos
        modal={modalverproyectos}
        CancelarModal={() => {
          setModalVerProyectos(false);
        }}
        jurado={juradoseleccionado}
        codigo={juradoseleccionado.codigo}
        lineasconvocatoria={lineasconvocatoria}
      />
    </>
  );
};
